var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c("div", { staticClass: "login-weaper animated bounceInDown" }, [
        _c("div", { staticClass: "login-logo" }),
        _c("p", { staticClass: "login-tip" }, [
          _vm._v(_vm._s(_vm.website.title)),
        ]),
        _c("div", { staticClass: "login-border" }, [
          _c(
            "div",
            { staticClass: "login-main" },
            [
              _c("h4", { staticClass: "login-title" }),
              _vm.activeName === "user"
                ? _c("userLogin")
                : _vm.activeName === "code"
                ? _c("codeLogin")
                : _vm.activeName === "third"
                ? _c("thirdLogin")
                : _vm._e(),
              _c("div", { staticClass: "login-menu" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.activeName = "user"
                      },
                    },
                  },
                  [_vm._v("账号密码")]
                ),
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.activeName = "code"
                      },
                    },
                  },
                  [_vm._v("手机号登录")]
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "login-copyright" }, [
        _vm._v("\n\t\t\t" + _vm._s(_vm.website.copyright) + "\n\t\t"),
      ]),
      _c("top-color", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }